import { Subscription } from 'rxjs';

/** Tempo de espera após a última tecla antes de disparar a busca no servidor. */
export const DEBOUNCE_BUSCA_MS = 300;

/** Intervalo para ignorar clique duplo no botão Pesquisar. */
export const DEBOUNCE_PESQUISA_MS = 400;

/** Mínimo de caracteres para disparar busca server-side (padrão do SIDAC). */
export const MIN_CHARS_BUSCA = 3;

/**
 * Evita request a cada tecla: só chama a API depois que o usuário para de digitar.
 * Cancela o timer pendente e a subscription anterior a cada nova digitação.
 */
export class DebouncedSearch {
  private timer: ReturnType<typeof setTimeout> | null = null;
  private subscription: Subscription | null = null;

  run(
    value: string | null | undefined,
    request: (termo: string) => Subscription,
    minLength: number = MIN_CHARS_BUSCA,
    debounceMs: number = DEBOUNCE_BUSCA_MS,
  ): void {
    this.cancelPending();

    const termo = (value ?? '').trim();
    if (termo.length < minLength) {
      return;
    }

    this.timer = setTimeout(() => {
      this.subscription = request(termo);
    }, debounceMs);
  }

  cancelPending(): void {
    if (this.timer != null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}

/**
 * Primeiro clique dispara na hora; cliques seguintes no intervalo são ignorados.
 */
export class ClickThrottle {
  private locked = false;
  private timer: ReturnType<typeof setTimeout> | null = null;

  run(action: () => void, cooldownMs: number = DEBOUNCE_PESQUISA_MS): void {
    if (this.locked) {
      return;
    }
    this.locked = true;
    action();
    this.timer = setTimeout(() => {
      this.locked = false;
      this.timer = null;
    }, cooldownMs);
  }

  destroy(): void {
    if (this.timer != null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.locked = false;
  }
}
